import { Icon as _Icon } from "@src/components/ui-kit/Icon";

export const Icon = () => (
  <_Icon name="bell-03" color="#637381" style={{ transform: "scale(1.3)" }} />
);
